export default __webpack_public_path__ + "static/media/GooglePlay.a08f9a89.webp";